module.exports = __webpack_public_path__ + "img/appleWalletbutton.84dc6c7f.png";